import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';
import { Card, CardContent } from './ui/card';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            What Our Clients Say
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Don't just take our word for it - hear from our satisfied customers across West Midlands
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <Card key={testimonial.id} className="relative overflow-hidden border-2 hover:border-amber-500 hover:shadow-xl transition-all duration-300">
              <CardContent className="pt-6">
                {/* Quote Icon */}
                <div className="absolute top-4 right-4 text-amber-200">
                  <Quote size={48} fill="currentColor" />
                </div>

                {/* Stars */}
                <div className="flex gap-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={18} className="text-amber-500 fill-amber-500" />
                  ))}
                </div>

                {/* Review Text */}
                <p className="text-slate-700 mb-6 leading-relaxed relative z-10">
                  "{testimonial.text}"
                </p>

                {/* Service Tag */}
                <div className="mb-4">
                  <span className="inline-block px-3 py-1 bg-amber-100 text-amber-700 text-sm rounded-full">
                    {testimonial.service}
                  </span>
                </div>

                {/* Author Info */}
                <div className="border-t pt-4">
                  <p className="font-semibold text-slate-900">{testimonial.name}</p>
                  <p className="text-sm text-slate-600">{testimonial.location}</p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust Badge */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2 bg-slate-100 px-6 py-3 rounded-full">
            <Star className="text-amber-500 fill-amber-500" size={20} />
            <span className="text-slate-700 font-medium">Rated 5.0 out of 5 based on customer reviews</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;